import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@tanstack/react-router';
import { useAuthnProvider } from '@ui/auth';
import { STORAGE_KEYS } from '@ui/constants';
import { Avatar, AvatarFallback, AvatarImage } from '@ui/primitives/avatar';
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '@ui/primitives/dropdown-menu';
import { getAbbreviation } from '@ui/primitives/utils';
import { RouteNames, authenticated_user_profile_path, organization_managed_applications_path, organization_projects_path, useTypedParams } from '@ui/routes';
import { useCurrentUser } from '@ui/user-context';
import { Folder, LogOut, Package, Settings, User } from 'lucide-react';
export function HeaderUserMenu() {
    var _userApi_portrait;
    const { organization } = useTypedParams();
    const { user: userApi } = useCurrentUser();
    const { logout } = useAuthnProvider();
    if (!userApi) {
        return null;
    }
    const handleLogout = async ()=>{
        try {
            if (typeof window !== 'undefined') {
                localStorage.removeItem(STORAGE_KEYS.LAST_VISITED_ORG);
            }
        } catch (error) {
            //eslint-disable-next-line no-console
            console.error('Error clearing localStorage:', error);
        }
        await logout();
    };
    const menuItems = [
        {
            label: 'My Profile',
            icon: User,
            href: authenticated_user_profile_path()
        },
        ...organization ? [
            {
                label: 'Your Projects',
                icon: Folder,
                href: organization_projects_path({
                    organization: {
                        name: organization
                    }
                })
            },
            {
                label: 'Your Applications',
                icon: Package,
                href: organization_managed_applications_path({
                    organization: {
                        name: organization
                    }
                })
            }
        ] : [],
        {
            label: 'Your Organizations',
            icon: Settings,
            href: RouteNames.PERSONAL_DASHBOARD
        }
    ];
    return /*#__PURE__*/ _jsxs(DropdownMenu, {
        children: [
            /*#__PURE__*/ _jsx(DropdownMenuTrigger, {
                className: "cursor-pointer",
                "data-e2e": "LAYOUT_HEADER__PROFILE_MENU",
                children: /*#__PURE__*/ _jsxs(Avatar, {
                    "data-e2e": "PROFILE_MENU__USER_AVATAR",
                    children: [
                        /*#__PURE__*/ _jsx(AvatarImage, {
                            src: (_userApi_portrait = userApi.portrait) !== null && _userApi_portrait !== void 0 ? _userApi_portrait : '',
                            alt: userApi.name
                        }),
                        /*#__PURE__*/ _jsx(AvatarFallback, {
                            children: getAbbreviation(userApi.name)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(DropdownMenuContent, {
                side: "bottom",
                align: "end",
                sideOffset: 8,
                className: "w-64 text-gray-25 border-border",
                "data-e2e": "LAYOUT_HEADER__PROFILE_DROPDOWN",
                children: [
                    /*#__PURE__*/ _jsx(DropdownMenuGroup, {
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "grid p-2 flex-1 text-left text-sm leading-tight",
                            "data-e2e": "LAYOUT_HEADER__PROFILE_DROPDOWN_USER_INFO",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "truncate font-medium",
                                    children: userApi.name
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "truncate text-xs text-muted-foreground",
                                    children: userApi.email
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(DropdownMenuSeparator, {}),
                    /*#__PURE__*/ _jsx(DropdownMenuGroup, {
                        children: menuItems.map((item)=>{
                            var _item_href;
                            return /*#__PURE__*/ _jsx(DropdownMenuItem, {
                                asChild: true,
                                children: /*#__PURE__*/ _jsxs(Link, {
                                    to: (_item_href = item.href) !== null && _item_href !== void 0 ? _item_href : undefined,
                                    className: "cursor-pointer",
                                    "data-e2e": "LAYOUT_HEADER__PROFILE_DROPDOWN_ITEM",
                                    "data-item-label": item.label,
                                    children: [
                                        /*#__PURE__*/ _jsx(item.icon, {}),
                                        item.label
                                    ]
                                })
                            }, item.label);
                        })
                    }),
                    /*#__PURE__*/ _jsx(DropdownMenuSeparator, {}),
                    /*#__PURE__*/ _jsxs(DropdownMenuItem, {
                        onClick: ()=>void handleLogout(),
                        className: "cursor-pointer",
                        "data-e2e": "LAYOUT_HEADER__PROFILE_DROPDOWN_SIGN_OUT",
                        children: [
                            /*#__PURE__*/ _jsx(LogOut, {}),
                            "Sign Out"
                        ]
                    })
                ]
            })
        ]
    });
}
